export default "__VITE_ASSET__Cz5k3tEv__"